import { render, staticRenderFns } from "./ProOffers.vue?vue&type=template&id=dc0825e4&scoped=true"
import script from "./ProOffers.vue?vue&type=script&lang=js"
export * from "./ProOffers.vue?vue&type=script&lang=js"
import style0 from "./ProOffers.vue?vue&type=style&index=0&id=dc0825e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0825e4",
  null
  
)

export default component.exports